export default __webpack_public_path__ + "static/media/AngleRightDark.0df226f5.svg";